import React, { forwardRef } from 'react';
import clsx from 'clsx';
import AlertOutline from '@mollie/ui-assets/icons/utilitarian/AlertOutline';
import { Icon } from '../Icon';
import { suffixId } from '../../utils';
import { Box } from '../Box';
import './FormField.css';
export const FormField = forwardRef((props, ref) => {
    const { children, className, htmlFor, label, labelElementType = 'label', validationText, helperText, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-form-field', className), ref: ref },
        label &&
            React.createElement(labelElementType, {
                className: 'mollie-ui-form-field-label',
                id: labelId(htmlFor),
                htmlFor: labelElementType === 'label' ? htmlFor : undefined,
            }, label),
        children,
        validationText && (React.createElement("div", { className: "mollie-ui-form-field-validation-text", id: validationTextId(htmlFor) },
            React.createElement(Icon, { src: AlertOutline }),
            " ",
            validationText)),
        helperText && (React.createElement("div", { className: "mollie-ui-form-field-helper-text", id: helperTextId(htmlFor) }, helperText))));
});
export function labelId(id) {
    return suffixId(id, 'label');
}
export function helperTextId(id) {
    return suffixId(id, 'helperText');
}
export function validationTextId(id) {
    return suffixId(id, 'validationText');
}
//# sourceMappingURL=FormField.js.map